import React, { Component } from 'react';
import PropTypes from 'prop-types';


import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";
import RecordAction from "../Display/RecordAction";
import ActionHistoryTag from "../Tags/ActionHistoryTag"

const ClaimNumberRecordTable = ({ list, onErrorClick, onClaimIDClick }) => {
  if (!list){
    return (
      <div/>
    );
  }
  return (
    <div className="grid tight">
      <span>Það eru {list.length} skuldari(ar)</span>
      {list.map(function(debtor,d){
        return(
          <div key={d} className="calc-setting-table ">
            <table className="table">
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
              <tr>
                <th colSpan="10" className="text-left calc-setting-table-header">Skuldari {debtor.debtorRegno}</th>
              </tr>
              <tr>
                <th className="text-left">TrackID</th>
                <th className="text-left">BatchID</th>
                <th className="text-left">Aðgerð</th>
                <th className="text-left">ClaimID</th>
                <th className="text-left">Staða</th>
                <th className="text-left">Fyrst skráð</th>
                <th className="text-left">Skráð af</th>
                <th className="text-left">Síð. uppf.</th>
                <th className="text-left">Uppf. af</th>
                <th className="text-left">Niðurstaða.</th>
              </tr>
              </thead>
              <tbody>
              {debtor.records.map(function(item,i){
                return(
                  <tr key={i}>
                    <td className="text-left">{item.trackID.toString()} </td>
                    <td className="text-left">{item.batchID.toString()} </td>
                    <td className="text-left"><RecordAction data={item.recordAction}/> </td>
                    {item.claimID && <td className="text-left"><a onClick={(e)=>onClaimIDClick(e,item)}>{item.claimID.toString()}</a> </td>}
                    {!item.claimID && <td className="text-left"> </td>}
                    { item.claimState === 4 && <td className="text-left"><a onClick={(e)=>onErrorClick(e,item)}><ClaimState data={item.claimState}/></a> </td>}
                    { item.claimState !== 4 && <td className="text-left"><ClaimState data={item.claimState}/></td>}
                    <td className="text-left"><DateTime data={item.insertedDate}/></td>
                    <td className="text-left">{item.insertedByUsername} </td>
                    <td className="text-left"><DateTime data={item.updatedDate}/></td>
                    <td className="text-left">{item.updatedByUsername} </td>
                    <td className="text-left">
                    {item.actionHistory.map(function(action, a){
                       if(item.claimState === 4){
                         action.actionDate = item.updatedDate;
                       }
                        //console.debug('Action', action, item);                      
                      return(
                        <div key={a}>
                          <ActionHistoryTag item={action}/> <br/>
                        </div>
                      );
                    })}
                    </td>
                  </tr>);
              })}
              </tbody>
            </table>
          </div>);})}
    </div>
  );
};

ClaimNumberRecordTable.propTypes = {
  list: PropTypes.array,
  onErrorClick : PropTypes.func,
  onClaimIDClick : PropTypes.func,
};

export default ClaimNumberRecordTable;




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/ClaimNumber/ClaimNumberRecordTable.js